import { IconType } from 'react-icons';
import { styled } from 'styled-components';
import { IoChevronForwardOutline } from 'react-icons/io5';

import { BlockData } from 'types';
import useMenuBlocks from '../../../hooks/useMenuBlocks';
import { FLOW_TYPE } from 'constants/flow';
import MenuBlock from '../../MenuBlock';
import { createBlockNodeDragData } from 'pages/Editor/utils/createNodeDragData';
import { EDITOR_HEADER_HEIGHT, FLOW_HEADER_HEIGHT, LAYER_MENU_PADDING } from 'constants/style';

const TITLE_HEIGHT = 40;
const BASE_HEIGHT = EDITOR_HEADER_HEIGHT + FLOW_HEADER_HEIGHT + LAYER_MENU_PADDING * 2;

const Title = styled.button`
  font-size: 16px;
  padding: 0px 12px;
  height: ${`${TITLE_HEIGHT}px`};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  svg {
    font-size: 20px;
  }
`;

const ArrowIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease-in-out;
`;

const Container = styled.div<{ $isSelected: boolean }>`
  ${ArrowIcon} {
    transform: ${(props) => (props.$isSelected ? `rotate(-90deg)` : 'rotate(90deg)')};
  }
`;

const GroupBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  padding: 4px 12px;
  max-height: ${`calc(100vh - ${BASE_HEIGHT + TITLE_HEIGHT * 5}px)`};
`;

interface BlockGroupProps {
  keyword: string;
  title: string;
  isSelected: boolean;
  blocks: BlockData[];
  Icon: IconType;
  onGroupClick: (newGroup: string) => void;
}

const BlockGroup = ({ keyword, title, isSelected, blocks, Icon, onGroupClick }: BlockGroupProps) => {
  const { filteredBlocks, onBlockDragStart } = useMenuBlocks({
    blocks,
    keyword,
    nodeType: FLOW_TYPE.NODE.NEW_NODE,
  });

  return (
    <Container $isSelected={isSelected}>
      <Title onClick={() => onGroupClick(title)}>
        <div>
          <Icon />
          <span>{title}</span>
        </div>
        <ArrowIcon>
          <IoChevronForwardOutline />
        </ArrowIcon>
      </Title>
      {isSelected && (
        <GroupBlock>
          {filteredBlocks.map((blockData) => (
            <MenuBlock
              Icon={Icon}
              key={`block${title}${blockData.name}`}
              blockColor={`#${blockData.blockColor}`}
              name={blockData.name}
              onDragStart={(event) =>
                onBlockDragStart(event, createBlockNodeDragData({ nodeType: FLOW_TYPE.NODE.LAYER_NODE, blockData }))
              }
            />
          ))}
        </GroupBlock>
      )}
    </Container>
  );
};

export default BlockGroup;
